/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import {Button, Col, FormControl, Row} from "react-bootstrap";
import {Glyphicon} from "../../../Components/Common/GlyphIcon";
import {ForgotPasswordPopup} from "../../../Components/Common/ForgotPasswordPopup";
import React from "react";
import {PermissionCheckerEnhance} from "../../../Components/Common/Enhancements";
import {connect} from "react-redux";

@PermissionCheckerEnhance
class _PasswordFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props);

		this.setInitialState({
			editing: props.IsNewModel,
			displayModal: false,
			valid: true,
			currentPassword: "",
			password1: "",
			password2: ""
		});

		if (props.IsNewModel) {
			props.OnUpdate({
				password: "",
				current: ""
			});
		} else {
			props.OnUpdate(null);
		}
	}

	@autobind
	toggleEditing() {
		this.setState({editing: !this.state.editing}, () => {
			if (!this.state.editing) {
				this.setState({
					currentPassword: "",
					password1: "",
					password2: ""
				}, () => {
					this.props.OnUpdate(null);
				});
			} else {
				this.props.OnUpdate({
					password: this.state.password1,
					current: this.state.currentPassword
				});
			}
		});
	}

	@autobind
	toggleModal() {
		this.setState({displayModal: !this.state.displayModal});
	}

	@autobind
	resetPassword() {
		this.toggleModal();
	}

	@autobind
	updateCurrentPassword(event) {
		this.setState({currentPassword: event.target.value}, () => {
			this.processPasswords();
		});
	}

	@autobind
	updatePassword1(event) {
		this.setState({password1: event.target.value}, () => {
			this.processPasswords();
		});
	}

	@autobind
	updatePassword2(event) {
		this.setState({password2: event.target.value}, () => {
			this.processPasswords();
		});
	}

	@autobind
	processPasswords() {
		if (this.state.password1 === this.state.password2) {
			this.setState({valid: true}, () => {
				this.props.OnUpdate({
					password: this.state.password1,
					current: this.state.currentPassword
				});
			});
		} else {
			this.setState({valid: false}, () => {
				this.props.OnUpdate(false);
			});
		}
	}

	@autobind
	_render() {
		return <div>
			{
				!this.props.IsNewModel ?
					<div className="sb-single-line-with-button-field-editor">
							<Button className="pndlm-button-grey" onClick={this.toggleEditing}>
								{
									this.state.editing ?
										"Cancel" :
										"Change"
								}
							</Button>
							<a className="pndlm-image-delete-reset-button" onClick={this.toggleModal}>
								<Glyphicon glyph="sync"/>
								Reset Password
							</a>
					</div> :
					null
			}
			{
				this.state.editing ?
					<div>
						<Row className="top17">
							<Col xs={12}>
								<FormControl
									autoComplete="current-password"
									type="password"
									placeholder={
										this.props.Data.userId !== this.props.user?.userId ?
											"Admin Password" :
											"Current Password"
									}
									value={this.state.currentPassword || ""}
									onChange={this.updateCurrentPassword}
								/>
							</Col>
						</Row>
						<Row className="top17">
							<Col xs={12}>
								<FormControl
									autoComplete="new-password"
									type="password"
									placeholder="Password"
									value={this.state.password1 || ""}
									onChange={this.updatePassword1}
								/>
							</Col>
						</Row>
						<Row className="top17">
							<Col xs={12}>
								<FormControl
									autoComplete="new-password"
									type="password"
									placeholder="Verify Password"
									value={this.state.password2 || ""}
									onChange={this.updatePassword2}
								/>
							</Col>
						</Row>
					</div> :
					null
			}
			<ForgotPasswordPopup
				DefaultEmail={this.props.Data.email}
				Display={this.state.displayModal}
				Close={() => this.setState({displayModal: false})}
			/>
		</div>;
	}
}

function mapStateToProps(state) {
	const { userState } = state;
	console.log(userState);
	return {
		user: userState?.user,
	}
}

export const PasswordFieldEditor = connect(mapStateToProps)(_PasswordFieldEditor);
